const features = {
  DASHBOARD: 'DASHBOARD',
  MEMBERS: 'MEMBERS',
  PLATFORM_ACCESS: 'PLATFORM_ACCESS',
};

export default features;
